import { useAtom } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { Array } from '@blade/std-lib'
import { SearchInput } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { InfoMessage } from '@root/shared/ui-kit'

import { reatomCheatSheetSearchModel } from '../model/reatom-cheat-sheet-search-model'

import { ShortcutCheatSheetList } from './shortcut-cheat-sheet-list'

export const ShortcutCheatSheetFilter: React.FC = () => {
  const { t } = useTranslation()
  // eslint-disable-next-line @reatom/unit-naming-rule
  const filterModel = useMemo(() => reatomCheatSheetSearchModel(), [])
  const [searchQuery, setSearchQuery] = useAtom(filterModel.searchQueryAtom)
  const [searchResults] = useAtom(filterModel.searchResultsAtom)

  return (
    <Root>
      <Top>
        <SearchInput
          placeholder={t('common.search')}
          size="s"
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
        />
      </Top>
      <List>
        {Array.match(searchResults, {
          onNonEmpty: (commands) => (
            <ShortcutCheatSheetList commands={commands} />
          ),
          onEmpty: () => (
            <InfoContainer>
              <InfoMessage
                intent={'empty'}
                variant="dt"
                title={t('common.no-results-found-for', { query: searchQuery })}
                description={t('common.try-changing-search-query')}
              />
            </InfoContainer>
          ),
        })}
      </List>
    </Root>
  )
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: 100%;
`
const Top = styled.div``
const List = styled.div``
const InfoContainer = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: 1fr auto;
`
